package com.macrofocus.eflux.network

import com.macrofocus.eflux.network.line.WeatherLineData
import com.macrofocus.eflux.network.logical.LogicalBranchId

open class WeatherNetworkCapability(
    val lineData: (LogicalBranchId) -> WeatherLineData
) : NetworkCapability